import { UploadedFile } from 'types/general';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { ClientPackage, FullClientPackage } from '../types';
import { SuccessData } from 'types/api';

type CreatePackageProps = Pick<
  ClientPackage,
  'client' | 'value' | 'currency' | 'complementaryFiles' | 'name'
> & {
  proofFile: ClientPackage['proofFile'] | null;
};

interface AttachProjectParams {
  packageId: string;
  quotationId?: string;
  projectId: string;
}

interface RemoveProjectParams {
  packageId: string;
  justification: string;
  projectId: string;
}

interface CancelPackageParams {
  packageId: string;
  justification: string;
}

interface ChangePackageValueParams {
  packageId: string;
  justification: string;
  value: string;
  proofFile: UploadedFile;
}

interface PackageToBalanceParams {
  packageId: string;
  justification: string;
  country: string;
}

export const packagesMutations = getMutations({
  createPackage: {
    action: async (payload: CreatePackageProps): Promise<{ ok: true }> => {
      return executeApiCall({
        path: '/invoice/packages',

        method: 'post',

        payload,
      });
    },
  },

  attackProjectToPackage: {
    action: async ({
      packageId,
      projectId,
      quotationId,
    }: AttachProjectParams): Promise<FullClientPackage> => {
      return executeApiCall({
        path: '/invoice/packages/projects',

        method: 'post',

        payload: {
          project: projectId,
          packageId,
          quotationId,
        },
      });
    },
  },

  removeProjectFromPackage: {
    action: async (payload: RemoveProjectParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/packages/projects',

        method: 'delete',

        payload,
      });
    },
  },

  cancelPackage: {
    action: async (payload: CancelPackageParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/packages/cancel',

        method: 'post',

        payload,
      });
    },
  },

  changePackageValue: {
    action: async (payload: ChangePackageValueParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/packages/value',

        method: 'put',

        payload,
      });
    },
  },

  convertPackageToBalance: {
    action: async (payload: PackageToBalanceParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/invoice/packages/convert-to-balance',

        method: 'post',

        payload,
      });
    },
  },

  downloadPackageProjectsExcel: {
    action: async (payload: { packageId: string }): Promise<Buffer> => {
      return executeApiCall({
        path: '/invoice/packages/projects-excel',

        method: 'post',

        responseType: 'blob',

        payload,
      });
    },

    messages: {
      error: (t) => ({
        title: t('excel-download-error'),
        type: 'error',
      }),
    },
  },
});
